import React from "react";
import DeprecatedFeatureCard from "../shared/DeprecatedFeatureCard";
import styles from "./SettingDeprecatedV2.module.css";

interface SettingDeprecatedV2Props {
  moduleName: string;
  redirectUrl: string;
  helpCenterUrl: string;
}

const SettingDeprecatedV2: React.FC<SettingDeprecatedV2Props> = ({
  moduleName,
  redirectUrl,
  helpCenterUrl,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <DeprecatedFeatureCard
          moduleName={moduleName}
          redirectUrl={redirectUrl}
          helpCenterUrl={helpCenterUrl}
        />
      </div>
    </div>
  );
};

export default SettingDeprecatedV2;
